import RouteGuard from '@app/components/RouteGuard';
import AppLayout from '@app/layouts/app-layout';
import { type PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

const PUBLIC_AUTH_PATHS = new Set([
    '/',
    '/auth',
    '/auth/forgot-password',
    '/auth/reset-password',
    '/auth/verify-email',
    '/auth/magic-link/verify',
]);

/**
 * Authentication is required by default. Only entry and account-recovery
 * screens owned by the auth module are public.
 *
 * Login and signup share `/auth`; signup is selected with the `signup` query
 * parameter, so query strings intentionally do not participate here.
 */
const isPublicPath = (pathname: string) => PUBLIC_AUTH_PATHS.has(pathname);

export default function AuthenticatedAppFrame({ children }: PropsWithChildren) {
    const { pathname } = useLocation();

    if (isPublicPath(pathname)) return children;

    return (
        <RouteGuard>
            <AppLayout>{children}</AppLayout>
        </RouteGuard>
    );
}
